'use client';

import Icon from '@/components/ui/AppIcon';

const ContactContent = () => {
  return (
    <>
      {/* Hero */}
      <div
        className="py-16 lg:py-24"
        style={{
          background: 'linear-gradient(180deg, #0B1622 0%, #0A0E14 100%)',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <div
              className="inline-flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium mb-4"
              style={{
                background: 'rgba(111,211,224,0.10)',
                color: '#6FD3E0',
                border: '1px solid rgba(111,211,224,0.20)',
              }}
            >
              <Icon name="EnvelopeIcon" size={16} />
              <span>Get in Touch</span>
            </div>

            <h1
              className="text-4xl lg:text-6xl font-headline font-bold"
              style={{ color: '#EAF4F8' }}
            >
              Contact Us
            </h1>

            <p
              className="text-lg lg:text-xl leading-relaxed max-w-3xl mx-auto"
              style={{ color: '#C8DDE6' }}
            >
              Have a question, dive report, or story to share? We'd love to hear from you.
            </p>
          </div>
        </div>
      </div>

      {/* Email contact section */}
      <div className="container mx-auto px-4 py-16 lg:py-24">
        <div className="max-w-2xl mx-auto text-center">
          <div
            className="rounded-2xl p-10 lg:p-14"
            style={{
              background: '#0F2234',
              border: '1px solid rgba(111,211,224,0.15)',
              boxShadow: '0 4px 20px rgba(0,0,0,0.30)',
            }}
          >
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
              style={{
                background: 'rgba(111,211,224,0.10)',
                border: '1px solid rgba(111,211,224,0.20)',
              }}
            >
              <Icon name="EnvelopeIcon" size={32} style={{ color: '#6FD3E0' }} />
            </div>

            <h2
              className="text-2xl lg:text-3xl font-headline font-bold mb-4"
              style={{ color: '#EAF4F8' }}
            >
              Send Us an Email
            </h2>

            <p
              className="text-base lg:text-lg leading-relaxed mb-8"
              style={{ color: '#C8DDE6' }}
            >
              For general enquiries, article submissions, dive reports, or photo contributions,
              please email us directly at:
            </p>

            <a
              href="mailto:hello@cyprusdiving.info"
              className="inline-block text-xl lg:text-2xl font-semibold transition-opacity hover:opacity-80"
              style={{ color: '#6FD3E0' }}
            >
              hello@cyprusdiving.info
            </a>

            <p
              className="text-sm mt-6"
              style={{ color: '#7A9BAD' }}
            >
              We read every message and will get back to you as soon as we can.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactContent;
